// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  apiUrl: 'https://prx.webapp.gurumuseumsystems.com/v1/',
  // apiDomainName: 'hmla.guru-webapp.i2asolutions.com',
  // apiUrl: 'http://192.168.0.117:8010/proxy/api/v1/',
  apiDomainName: 'sch.guru-webapp.i2asolutions.com',
  //apiUrl: 'http://museumibeacon-stg.qa-aws.i2asolutions.com/api/v1/',
  appId: 38,
  appTitle: 'Holocaust Museum LA Tours',
  appShortTitle: 'Tours',
  // apiRoot: 'https://apps.theguru.co/api'
  apiRoot: 'https://prx.webapp.gurumuseumsystems.com/',
  navApi: "https://nav.webapp.gurumuseumsystems.com/"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
